import React__default from 'react';
import { TransitionGroup, Transition } from 'react-transition-group';
import { HubbleProvider } from '../ThemeProvider/index.js';
import { TOASTER_DURATIONS } from './constants.js';
import { ToasterContainer } from './styles.js';
import { Toast } from './Toast.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const ToasterContext = React__default.createContext({
  showToast: toast => ({
    ...toast
  }),
  hideToast: () => {}
});
const useToaster = () => {
  const context = React__default.useContext(ToasterContext);
  if (context === undefined) {
    throw new Error('useToaster must be used within a ToasterProvider');
  }
  return context;
};
const ToasterProvider = ({
  children
}) => {
  const [toasts, setToasts] = React__default.useState([]);
  const hideToast = React__default.useCallback(uuid => setToasts(current => current.filter(toast => toast.uuid !== uuid)), []);
  const showToast = React__default.useCallback(toast => {
    const newToast = {
      uuid: String(new Date().valueOf()),
      ...toast
    };
    setToasts(current => [...current, newToast].slice(-2));
    return newToast;
  }, []);
  return jsxs(ToasterContext.Provider, {
    value: {
      showToast,
      hideToast
    },
    children: [children, jsx(Toaster, {
      toasts: toasts,
      hideToast: hideToast
    })]
  });
};
const Toaster = ({
  hideToast,
  toasts
}) => jsx(ToasterContainer, {
  children: jsx(HubbleProvider, {
    inverse: true,
    children: jsx(TransitionGroup, {
      component: null,
      children: toasts.map(toast => jsx(Transition, {
        timeout: TOASTER_DURATIONS.transition,
        children: transitionStatus => jsx(Toast, {
          hideToast: hideToast,
          transitionStatus: transitionStatus,
          ...toast
        }, toast.uuid)
      }, `transition-${toast.uuid}`))
    })
  })
});

export { Toaster, ToasterProvider, useToaster };
